module.exports = __webpack_public_path__ + "img/chevron-left.94dcf5c7.svg";